import { FC } from 'react';

import { GiftCouponSummary } from '@shared/api/giftCoupon/giftCoupon.interface';
import { formatPrice } from '@shared/utils/formatPrice';

import { GiftItemEmbed } from './types';

interface CancelSectionProps {
  cancellableCoupons: GiftCouponSummary[];
  selectedIds: Set<string>;
  isFullCancel: boolean;
  // 가상계좌/입금 결제 — 취소 시 부트페이 자동취소 대신 수동환불(환불이체) 모달
  isManualRefund: boolean;
  giftItemEmbedMap: Map<string, GiftItemEmbed>;
  toggleSelectAll: () => void;
  onRequestCancel: () => void;
}

export const CancelSection: FC<CancelSectionProps> = ({
  cancellableCoupons,
  selectedIds,
  isFullCancel,
  isManualRefund,
  giftItemEmbedMap,
  toggleSelectAll,
  onRequestCancel,
}) => {
  // 선택된 취소대상 쿠폰의 환불 예정액 합계 (표시용).
  // 판매가 base는 주문 스냅샷 giftItemEmbed.priceRetail (구매 당시 동결값)로,
  // 쿠폰표(CouponRow)에서 쓰는 값과 동일하다.
  const selectedTotal = cancellableCoupons.reduce(
    (sum, c) =>
      selectedIds.has(c._id)
        ? sum + (giftItemEmbedMap.get(c.giftItem)?.priceRetail ?? 0)
        : sum,
    0,
  );
  return (
    <div className="flex shrink-0 items-center justify-between rounded-lg border border-red-200 bg-red-50 px-4 py-2.5">
      <div className="flex items-center gap-3">
        <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            checked={
              selectedIds.size === cancellableCoupons.length &&
              cancellableCoupons.length > 0
            }
            onChange={toggleSelectAll}
            className="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-500"
          />
          취소 가능 전체선택 ({cancellableCoupons.length}건)
        </label>
        {selectedIds.size > 0 && (
          <span className="text-xs text-red-600">
            {selectedIds.size}건 · {formatPrice(selectedTotal)}원 선택됨
            {isFullCancel ? ' (전체취소)' : ' (부분취소)'}
          </span>
        )}
      </div>
      {selectedIds.size > 0 && (
        <button
          onClick={onRequestCancel}
          className={`rounded-lg px-4 py-1.5 text-sm font-bold text-white ${
            isManualRefund
              ? 'bg-blue-600 hover:bg-blue-700'
              : 'bg-red-600 hover:bg-red-700'
          }`}
        >
          {isManualRefund ? '선택 쿠폰 취소 (환불이체)' : '선택 쿠폰 취소'} (
          {selectedIds.size}건 · {formatPrice(selectedTotal)}원)
        </button>
      )}
    </div>
  );
};
